<template>
    <div class="addModel myinput">
      <div>
        <div class="emid">
          <div class="bnt">
            <span>货架名称</span>
            <el-input v-model="query.shelfname" maxlength="100" ></el-input>
          </div>
          <div class="bnt">
            <span>货架描述</span>
            <el-input v-model="query.remark" maxlength="100" ></el-input>
          </div>
          <div class="bnt">
            <span>排序</span>
            <el-input v-model="query.number" @input="query.number=query.number.replace(/[^\d]/g,'')" maxlength="10" ></el-input>
          </div>
          <div style="display: flex;" v-if="qrcodeLink">
            <span style="margin-right: 20px;">货架二维码</span>
            <div class="demo-image__preview">
  <el-image 
    style="width: 100px; height: 100px"
    :src="qrcodeLink" 
    :preview-src-list="[qrcodeLink]">
  </el-image>
</div>
          </div>
          
        </div>
      </div>
      <div class="detailed">
        <div class="element-list jb-bg btn" @click="submit">确认</div>
        <div class="element-list jb-bg btn" @click="cancel">取消</div>
      </div>
    </div>
  </template>
  
  <script>
  import {
    getDetail
} from "@/api/warehouse";
  export default {
    props: {
      pInfo: Object,
      maxNum:Number

    },
    data() {
      return {
        qrcodeLink:null,
        depotId: "", 
        query:{
          remark: "", 
            number: "", 
            shelfname:''
        }
       
      };
    },
    created() {
      this.depotId = sessionStorage.getItem("depotId");
    },
    methods: {
      getInfo(id) {
        getDetail(id).then((res) => {
        if (res.code == 200) {
          this.qrcodeLink = res.data.qrcodeLink
          
        }
      });
    },
      submit() {
        if (!this.query.shelfname) {
          return this.$message.error("请输入货架名称");
        }
        if (!this.query.number) {
          return this.$message.error("请输入排序");
        }
        this.$emit("submit",this.query);
      },
      cancel() {
        this.$emit("cancel");
      },
    },
    watch: {
    maxNum:{
        handler: function(newUser, oldUser) {
          if(!this.pInfo){
            this.query.number = newUser
          }
      },
      immediate: true,
      deep: true // 设置 deep 选项为 true，实现深度监听
    },
    pInfo:{
        handler: function(newUser, oldUser) {
          if(newUser){
            Object.assign(this.query,newUser)
            this.getInfo(newUser.id)
          }
      },
      immediate: true,
      deep: true // 设置 deep 选项为 true，实现深度监听
    }
  }
  };
  </script>
  
  <style lang='less' scoped>
  .select_option {
    background: #092e5f !important;
    color: #ffffff !important;
  }
  .addModel {
    height: 450px;
    color: #74c8fe;
    margin: 0 30px;
    .addemBtns {
      margin: 30px 10px;
      font-size: 20px;
    }
    .emid {
      height: 50px;
      line-height: 50px;
      .el-input {
        width: 260px;
        margin: 0px 15px;
      }
      span {
        display: -moz-inline-box;
        display: inline-block;
        width: 85px;
        text-align: center;
        text-align-last: justify;
      }
    }
  
    .detailed {
      margin: 0 30px 20px;
      clear: both;
      display: flex;
      position: absolute;
      bottom: 0px;
      .btn {
        width: 150px;
        margin-right: 10px;
        cursor: pointer;
      }
  
      .element-list {
        border: 2px solid#0090F0;
        border-radius: 6px;
        height: 30px;
        line-height: 30px;
        margin: 10px 5px;
        text-align: center;
      }
      .jb-bg {
        background-image: linear-gradient(#0479b4, #02407e);
      }
    }
  }
  .bnt{
    margin-bottom: 15px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/warehouse/components/addContainer.vue